module.exports = __webpack_public_path__ + "img/coinbankB20.f675ff9b.jpg";